export enum Methods {
    ADD,
    DELETE
}